module.exports = __webpack_public_path__ + "static/media/3e155a4da686d184.dc580b7c.png";